var map = {
	"./components/AsideRightMenu.vue": 1943,
	"./components/Cart.vue": 9482,
	"./components/CartMenuIcon.vue": 497,
	"./components/CartPopup.vue": 3812,
	"./components/Checkout.vue": 9618,
	"./components/CheckoutManual.vue": 9125,
	"./components/DeleteAddressPopup.vue": 1199,
	"./components/LoginPopup.vue": 9515,
	"./components/NewAddressPopup.vue": 2312,
	"./components/Notifications.vue": 7414,
	"./components/ProductBuy.vue": 2150,
	"./components/ProductBuySimple.vue": 5104,
	"./components/ProductDisplayYearAndPrice.vue": 2845,
	"./components/ProductSidePopup.vue": 7413,
	"./components/ShopMenuIcon.vue": 158,
	"./components/SimpleCartIcon.vue": 2907,
	"./components/UserMenu.vue": 3610,
	"./components/VisitSidePopup.vue": 374,
	"./components/partials/ContactForm.vue": 7323,
	"./components/partials/DiscountBox.vue": 5384,
	"./components/partials/Newsletter.vue": 1166,
	"./components/partials/OrderAnalytics.vue": 7446,
	"./components/partials/RegistrationAnalytics.vue": 4542,
	"./components/partials/VisitForm.vue": 7959,
	"./components/partials/WineClubPopup.vue": 8525,
	"./components/user-account/AccountUserAddresses.vue": 2469,
	"./components/user-account/AccountUserBilling.vue": 9887,
	"./components/user-account/AccountUserData.vue": 6434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;